// src/ArchiveTickIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ArchiveTickIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.418 1.834H6.582a3.546 3.546 0 0 0-3.539 3.538v12.916c0 1.65 1.183 2.347 2.631 1.55l4.473-2.485c.477-.266 1.247-.266 1.714 0l4.474 2.484c1.448.807 2.63.11 2.63-1.549V5.372a3.56 3.56 0 0 0-3.547-3.538",
          stroke: "#fff",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "m8.79 10.083 1.376 1.375 3.666-3.667",
          stroke: "#fff",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
var ArchiveTickIcon_default = ArchiveTickIcon;

export {
  ArchiveTickIcon_default
};
